import Star from './Star'

export default Star
// eslint-disable-next-line import/export
export * from './Star'
